import { API_ENDPOINT } from '../../config'
import customFetch from '../../utils/customFetch'
import { ExperimentKey, ExperimentVariationFor } from '../../utils/experiments/experiments'

const EXPERIMENTS_API_PATH = '/anbieten/private-anbieter/inserieren/api/experiments'

type ExperimentVariationResponse = {
  active: boolean
  variation: string | null
}

const getJsonRequestOptions = () => ({
  method: 'GET',
  headers: {
    Accept: 'application/json; charset=utf-8',
    'Content-Type': 'application/json; charset=UTF-8',
  },
  credentials: 'include' as const,
})

export const loadExperimentVariation = async <T extends ExperimentKey>(
  experimentKey: T
): Promise<ExperimentVariationFor<T> | undefined> => {
  const response = await customFetch(
    API_ENDPOINT + `${EXPERIMENTS_API_PATH}/${encodeURIComponent(experimentKey)}/variation`,
    getJsonRequestOptions()
  )

  if (response.status !== 200) {
    const body = await response.text()
    const truncatedBody = body.length > 200 ? `${body.substring(0, 200)}...` : body
    throw new Error(
      `Cannot load experiment ${experimentKey}, failed with ${response.status} and message ${truncatedBody}`
    )
  }

  const result = (await response.json()) as ExperimentVariationResponse
  return result.active && result.variation ? (result.variation as ExperimentVariationFor<T>) : undefined
}
